<template>
  <div class="flex-center">
    <i v-on:click="onSocialClick('vk')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'vk']" :style="{fontSize: iconSize}"/>
    </i>
    <i v-on:click="onSocialClick('ig')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'instagram']" :style="{fontSize: iconSize}"/>
    </i>
    <i v-on:click="onSocialClick('gh')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'github']" :style="{fontSize: iconSize}" />
    </i>
    <i v-on:click="onSocialClick('tg')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'telegram']" :style="{fontSize: iconSize}"/>
    </i>  
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  components: {

  },
  data() {
        return {    
          socialUrls: {
            vk: 'https://vk.com/kzkvv',
            ig: 'https://instagram.com/k8lk',
            gh: 'https://github.com/kzkvv',
            tg: 'https://t.me/BEPHu_kOTA'
          },        
          iconSize: '100px'          
        }
    },
    created() {
      window.addEventListener("resize", this.onInit);
    },
    unmounted() {
      window.removeEventListener("resize", this.onInit);
    },
    methods: {

      onInit() {
        var w = window.innerWidth
        var cf = 7
        if (w < 180) {
          cf = 10
        }
        if (w < 700) {
          this.iconSize = (w / cf).toString(10) + 'px'          
        }
        else {
          this.iconSize = '100px'          
        }     
      },

      onSocialClick(name) {        
        window.open(this.socialUrls[name]);
      }
    },
    mounted() {
      this.onInit()
    }
}
</script> 